$('#searchForm').submit(function () {
  $(':input', this).each(function () {
    this.disabled = !($(this).val());
  });
});
